// extracted by mini-css-extract-plugin
export default {"contentBlock":"IntersectionWrapper_contentBlock__+tqnk","visible":"IntersectionWrapper_visible__rZH5b"};